import { ReactElement } from 'react';
import { BaseIcon } from '../BaseIcon';
import type { BaseIconProps } from '../BaseIcon';

export const StarIcon = ({ ...props }: Omit<BaseIconProps, 'children'>): ReactElement => {
  return (
    <BaseIcon width="16" height="16" viewBox="0 0 16 16" fill="none" hasLegacyStrokeStyles={true} {...props}>
      <g clipPath="url(#clip0_7283_11351)">
        <path
          d="M8.00001 2.3533L9.5668 5.69095L9.79353 6.17396L10.321 6.25455L13.9253 6.80522L11.2842 9.51238L10.9319 9.87359L11.0131 10.3716L11.6257 14.1289L8.48372 12.3924L8.00001 12.1251L7.51631 12.3924L4.37432 14.1289L4.98697 10.3716L5.06819 9.87358L4.7158 9.51238L2.07473 6.80522L5.67904 6.25455L6.2065 6.17396L6.43323 5.69095L8.00001 2.3533Z"
          strokeWidth="2"
          fill="none"
        />
      </g>
      <defs>
        <clipPath id="clip0_7283_11351">
          <rect width="16" height="16" transform="translate(0 0.000976562)" />
        </clipPath>
      </defs>
    </BaseIcon>
  );
};

StarIcon.displayName = 'StarIcon';
